// extracted by mini-css-extract-plugin
export default {"button":"mfgUhg","animatedgradient":"VG8GuX","icon":"mcx731","iconAnimate":"rzbq0r"};